module.exports = __webpack_public_path__ + "img/getraenkeallgemein.5845e901.jpg";